import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-unauthorized-access',
  imports: [RouterLink],
  templateUrl: './unauthorized-access.html',
  styleUrl: './unauthorized-access.scss',
})
export class UnauthorizedAccess {

}
